const Settings = () => {
  return <div>You made it to the setting page!</div>;
};

export default Settings;
